// extracted by mini-css-extract-plugin
module.exports = {"img":"hero_img__3Mb60","info":"hero_info__ymUCG","shadow":"hero_shadow__AcG67"};